$shm_hitalama_map_widget_float_ai_request $shm_hitalama_map_widget_float
	presets $shm_hitalama_map_widget_presets
		map <= map
	controls /
		<= Controls $mol_view
			sub /
				<= Request_type_label $mol_labeler
					title \Тип запроса
					- content /
					Content <= Request_type $mol_select
						Filter null
						dictionary <= req_type_dict *
							mol_dom \Новое приложение ($mol реактивность)
							new_app_html \Iframe (html)
							new_app \Новое приложение (компонент)
							- changes_full \Внесение изменений (полный промпт, для чата без контекста)
							html_changes_short \Внесение изменений в html (сокращенный промпт, для чата с контекстом)
							changes_short \Внесение изменений в компонент (сокращенный промпт, для чата с контекстом)
						value? <=> request_type? \mol_dom
				<= Form $shm_hitalama_map_widget_float_ai_request_form
				<= Buttons $mol_view
					sub /
						<= Copy $mol_button_copy
							theme \$mol_theme_base
							title \Скопировать промпт
							text <= prompt \
						<= Paste $mol_button_major
							sub /
								<= Paste_icon $mol_icon_content_paste
								\Вставить ответ из буфера обмена
							click? <=> paste? null
						<= Next $mol_button_major
							sub /
								<= Next_icon $mol_icon_plus
								\Следующий запрос
								<= Next_right_icon $mol_icon_chevron_double_right
							click? <=> next_request? null
	forms *
		mol_dom <= Mol_dom $shm_hitalama_map_widget_float_ai_request_mol_dom
			Widget <= that $shm_hitalama_map_widget_float_ai_request
		new_app_html <= New_app_html $shm_hitalama_map_widget_float_ai_request_html
			Widget <= that $shm_hitalama_map_widget_float_ai_request
		new_app <= New_app $shm_hitalama_map_widget_float_ai_request_component
			Widget <= that $shm_hitalama_map_widget_float_ai_request
		changes_short <= Changes $shm_hitalama_map_widget_float_ai_request_changes
			Widget <= that $shm_hitalama_map_widget_float_ai_request
		- changes_full <= Changes
		html_changes_short <= Html_changes $shm_hitalama_map_widget_float_ai_request_html_changes
			Widget <= that $shm_hitalama_map_widget_float_ai_request
